import { createSelector } from '@reduxjs/toolkit'
import { CashAuthState } from './reducer'
import { useAppSelector } from '../hooks'
import { CheckoutAppSelector } from '../store'

const cashAuthSelector: CheckoutAppSelector<CashAuthState> = (state) => state.cashAuth

export const loginIntentTokenSelector = createSelector(cashAuthSelector, (state) => state.loginIntentToken)
export const challengeTokenSelector = createSelector(cashAuthSelector, (state) => state.challengeToken)
export const attestationsSelector = createSelector(cashAuthSelector, (state) => state.attestations)
export const accessTokenSelector = createSelector(cashAuthSelector, (state) => state.accessToken)
export const journeyIdSelector = createSelector(cashAuthSelector, (state) => state.journeyId)
export const maskedDeliveryTargetSelector = createSelector(cashAuthSelector, (state) => state.maskedDeliveryTarget)

export const useLoginIntentToken = () => useAppSelector(loginIntentTokenSelector)
export const useChallengeToken = () => useAppSelector(challengeTokenSelector)
export const useCashAttestations = () => useAppSelector(attestationsSelector)
export const useAccessToken = () => useAppSelector(accessTokenSelector)
export const useJourneyId = () => useAppSelector(journeyIdSelector)
export const useMaskedDeliveryTarget = () => useAppSelector(maskedDeliveryTargetSelector)
